import { RouterProvider } from "@tanstack/react-router";
import { useQueryClient, useTRPC } from "./_app/api";
import { useConfig } from "./_app/config";
import { useIsFeatureEnabled } from "./_app/featureFlags";
import { useTranslation } from "./_app/i18n";
import { commonTranslations } from "./_app/i18n/commonTranslations";
import { MaintenancePage } from "./maintenanceMode/MaintenancePage";
import { router } from "./router";

export function App() {
  const t = useTranslation(commonTranslations);
  const config = useConfig();
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const showMaintenancePage = useIsFeatureEnabled(
    "showMaintenancePageInServicePortal"
  );

  if (showMaintenancePage) {
    return <MaintenancePage message={t("maintenance.message")} />;
  }

  return (
    <RouterProvider router={router} context={{ config, queryClient, trpc }} />
  );
}
